import {lightingState, addLight} from "../../state";

const FormatLightingData = (lightData) => {

    lightingState.developerControls = lightData.developerControls;
    Object.keys(lightData.lights).forEach(lightEntryKey => {
        addLight(lightEntryKey, lightData.lights[lightEntryKey]);
    });
  
};

export default FormatLightingData;
